export default __webpack_public_path__ + "static/media/avatar_135.3febb6fd.png";